import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, ListGroup } from "react-bootstrap";
import { getDate } from "../../../utils/dateTime";
import { BlogCard } from "./BlogCard";
import styles from "./resources.module.css";
import { DYNAMIC_ROUTES } from "../../../routes/RoutesPathes";

export const RelatedBlogsSidebar = ({ relatedBlogs }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.stickySidebarContent}>
      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-white border-0 pb-0">
          <h3 className="fw-bold mb-3">{t("titles.related_blogs")}</h3>
        </Card.Header>

        <Card.Body className="pt-1">
          <ListGroup>
            {relatedBlogs?.map((blog, idx) => (
              <Link
                key={idx}
                to={DYNAMIC_ROUTES.blogDetail(blog.slug)}
                className="text-decoration-none"
              >
                <BlogCard
                  slug={blog.slug}
                  coverImg={blog.cover_image}
                  title={blog[`title_${i18n.language}`] || blog.title}
                  date={getDate(blog.created_at, i18n.language)}
                />
              </Link>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
    </div>
  );
};
